import { useState, useEffect, useCallback } from 'react';

export interface NfcStatus {
  isSupported: boolean;
  isEnabled: boolean;
  error: string | null;
}

export interface UseNfcReturn extends NfcStatus {
  checkStatus: () => Promise<void>;
}

export function useNfc(): UseNfcReturn {
  const [status, setStatus] = useState<NfcStatus>({
    isSupported: false,
    isEnabled: false,
    error: null,
  });

  const checkStatus = useCallback(async () => {
    if (!('NDEFReader' in window)) {
      setStatus({
        isSupported: false,
        isEnabled: false,
        error: 'NFC is not supported on this browser. Web NFC only works on Chrome for Android.',
      });
      return;
    }

    setStatus({
      isSupported: true,
      isEnabled: true,
      error: null,
    });
  }, []);

  useEffect(() => {
    const id = requestAnimationFrame(() => { checkStatus(); });
    return () => cancelAnimationFrame(id);
  }, [checkStatus]);

  return {
    ...status,
    checkStatus,
  };
}

export function isNfcSupported(): boolean {
  return 'NDEFReader' in window;
}
